import type { ComputedRef, InjectionKey } from 'vue'
import { inject } from 'vue'
import type {
  AttachmentData,
  AttachmentMediaCategory,
  AttachmentVariant,
} from './types'

export interface AttachmentsContextValue {
  variant: ComputedRef<AttachmentVariant>
}

export interface AttachmentContextValue {
  data: ComputedRef<AttachmentData>
  mediaCategory: ComputedRef<AttachmentMediaCategory>
  remove: () => void
  variant: ComputedRef<AttachmentVariant>
}

export const AttachmentsKey: InjectionKey<AttachmentsContextValue> =
  Symbol('AttachmentsContext')

export const AttachmentKey: InjectionKey<AttachmentContextValue> =
  Symbol('AttachmentContext')

export function useAttachmentsContext() {
  const ctx = inject(AttachmentsKey)
  if (!ctx) {
    throw new Error('Attachment components must be used within <Attachments>')
  }

  return ctx
}

export function useAttachmentContext() {
  const ctx = inject(AttachmentKey)
  if (!ctx) {
    throw new Error(
      'Attachment child components must be used within <Attachment>'
    )
  }

  return ctx
}
